import { render, staticRenderFns } from "./AppHelp.vue?vue&type=template&id=3b460fb6&scoped=true"
import script from "./AppHelp.vue?vue&type=script&lang=js"
export * from "./AppHelp.vue?vue&type=script&lang=js"
import style0 from "./AppHelp.vue?vue&type=style&index=0&id=3b460fb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b460fb6",
  null
  
)

export default component.exports